import { Consumer } from '../Context'
import logo from '../assets/logo.png'
import logo2 from '../assets/logo2.png'
import Auth from './Auth'
import BackButton from './BackButton'
import Confirm from './Confirm'
import ExistingIncidents from './ExistingIncidents'
import Incident from './Incident'
import Login from './Login'
import NotAStudent from './NotAStudent'

/**
 * Picks the current step. Previously a five-deep nested ternary that indexed
 * student['incidents'] unguarded - when the API returned anything that was not a
 * student object, the whole tree threw and the kiosk went blank.
 */
function currentStep({ key, submitted, studentExists, student, isStudent }) {
  if (!key) return <Auth />
  if (submitted) return <Confirm />
  if (studentExists) {
    return student?.incidents?.length > 0 ? <ExistingIncidents /> : <Incident />
  }
  return isStudent ? <Login /> : <NotAStudent />
}

/**
 * The banner above the current step.
 *
 * Derived from the same state currentStep() reads, and deliberately checked in
 * the same order, because the two used to disagree: createIncident/updateIncident
 * set `submitted` but leave `student` populated, so a finished check-in still
 * matched a bare `student` test and told the student to "finish the form" while
 * Confirm directly below it said they were already done.
 */
function bannerMessage({ key, submitted, student }) {
  if (!key) return 'Please sign in so we can further assist you.'
  if (submitted) return `Thanks ${student ? student.name : 'for checking in'}!`
  if (student) {
    return `Hey ${student.name}! Please finish the form and one of our members will assist you!`
  }
  return 'Please sign in so we can further assist you.'
}

export default function Home() {
  return (
    <Consumer>
      {(props) => (
        <section id="page__home">
          <section className="login">
            <div className="login__left d-none d-lg-flex d-xl-flex">
              <img src={logo} alt="NYIT College of Osteopathic Medicine" className="logo mx-4" />
              <div className="wrapper px-4 d-flex flex-grow-1 align-items-center">
                <div className="login__left__text">
                  <h3 style={{ fontWeight: 700 }}>
                    Welcome to <br /> ATG&apos;s Student Support Kiosk
                  </h3>
                </div>
              </div>
            </div>
            <div className="login__right">
              <img
                src={logo2}
                alt="NYIT College of Osteopathic Medicine"
                className="logo mx-4 d-flex d-sm-flex d-md-flex d-lg-none"
              />
              <BackButton className="d-none d-lg-flex d-xl-flex" onClick={props.resetForm} />
              <div className="wrapper px-5 mx-auto d-flex flex-column flex-grow-1 justify-content-center">
                <div className="mt-4 bg-gray">
                  <h2 className="font-weight-bold">{!props.student && 'Sign In'}</h2>
                  <p
                    className={
                      props.submitted
                        ? 'alert alert-success mb-5'
                        : props.student
                          ? 'alert alert-primary mb-5'
                          : ''
                    }
                  >
                    {bannerMessage(props)}
                  </p>
                  {currentStep(props)}
                  {props.errors ? (
                    <p className="text-danger" role="alert">
                      {props.errors}
                    </p>
                  ) : null}
                </div>
              </div>
              <BackButton className="d-flex d-sm-flex d-md-flex d-lg-none" onClick={props.resetForm} />
            </div>
          </section>
        </section>
      )}
    </Consumer>
  )
}
